/** Validating ShareofNominee fields in populatedForms */
export function validateShareOfNominee(
    populatedForms,
    arrayindex,
    DeleteHandler
  ) {
    const totalShares = getTotalSharesOfNominee(populatedForms);
  
    if (arrayindex === 0 && totalShares === 100) {
      // managing an temp array to manage state, bacause when we call DeleteHandler(i), it delete that form and changes the state immediately, but in loop we have old populatedForms state
      let tempIndexManageArray = [];
      if (populatedForms && populatedForms.nomineeDetails) {
        for (let i = 0; i < populatedForms.nomineeDetails.length; i++) {
          tempIndexManageArray.push(i);
        }
  
        populatedForms.nomineeDetails.every((form, i) => {
          if (form.ShareofNominee === "") {
            const newIndex = tempIndexManageArray.indexOf(i);
            // removing the form
            DeleteHandler(newIndex);
            // remove that index from tempIndexManageArray
            tempIndexManageArray.splice(newIndex, 1);
          }
          return true;
        });
      }
    }
  
    return getErrorMessage(totalShares);
  }
  
  /**
   * It returns an error message if the total shares of the nominees is not 100.
   * @param totalShares - the value of the input field
   * @returns the error message.
   */
  const getErrorMessage = (totalShares) => {
    let error;
    // when val === ""
    if (totalShares === 0) {
      error = "Share of Nominee is required";
    } else if (totalShares < 100 || totalShares > 100) {
      error = "Total shares of nominees should be 100";
    }
    return error;
  };
  
  /**  Adding new form on blur, if needed */
  export function addNewFormOnBlur(
    populatedForms,
    AddHandler
  ) {
    const totalShares = getTotalSharesOfNominee(populatedForms);
  
    if (totalShares < 100) {
      // Adding a form if there are no extra form already populated
      let isAlreadyFormPopulated = false;
      populatedForms &&
        populatedForms.nomineeDetails &&
        populatedForms.nomineeDetails.every((form, i) => {
          isAlreadyFormPopulated = form.ShareofNominee === "";
          if (isAlreadyFormPopulated) return false;
          return true;
        });
      if (!isAlreadyFormPopulated)
        AddHandler();
    
    }
  }
  
  /** Getting total sum from all ShareofNominee fields values*/
  const getTotalSharesOfNominee = (populatedForms) => {
    let totalShares = 0;
    populatedForms &&
      populatedForms.nomineeDetails &&
      populatedForms.nomineeDetails.every((form, i) => {
        let share = Number(form.ShareofNominee);
        if (!isNaN(share)) totalShares += share;
        return true;
      });
    return totalShares;
  };
  

  export const ageValidation=(name,val)=>{
    //console.log('cust',name,(val))
    let error=''
    if(Number(val) <18 ){
      error=`${name} should not be less than 18`
      return error
    }else if(Number(val) > 55){
      error=`${name} should not be greater than 55`
      return error
    }
    return error
  }

  export const premiumProposedValidation=(name,val)=>{
    let error='';
    if(Number(val) < 15000 ){
      error=`${name} should not be less than 15000`
      return error
    }else if(Number(val) > 99999){
      error=`${name} should not be greater than 99999`
      return error
    }
    return error
  }